import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const index = document.querySelector('#index')
  if (index && !index.__vue_app__) {
    createApp({ components: { BaseAlert } }).mount(index)
  }
})
